// extracted by mini-css-extract-plugin
export var o_beneficios2 = "beneficios2-module--o_beneficios2--fe9cf";
export var o_beneficios2__card = "beneficios2-module--o_beneficios2__card--7e56b";
export var o_beneficios2__cards = "beneficios2-module--o_beneficios2__cards--ae1dd";
export var o_beneficios2__desc = "beneficios2-module--o_beneficios2__desc--a1bda";
export var o_beneficios2__icon = "beneficios2-module--o_beneficios2__icon--cee3f";
export var o_beneficios2__info = "beneficios2-module--o_beneficios2__info--f2448";
export var o_beneficios2__main = "beneficios2-module--o_beneficios2__main--665d4";